import React from 'react'

const FnContext = React.createContext({
    test: 'test', 
    countFn: () => {}, 
})

export default FnContext;